import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <button
      [type]="type"
      class="btn d-flex align-items-center position-relative"
      [class.icon-only]="text === ''"
      [class]="cssClasses"
      [title]="text"
      [disabled]="disabled"
      (click)="clicked.emit()"
      >
      <span class="material-symbols-outlined"> {{ icon }} </span>
      <span [title]="text" class="text-nowrap">{{ text }}</span>
      @if (showBadge) {
        <span
          class="position-absolute start-0 translate-middle-x badge rounded-pill"
          [class]="badgeClass"
          >
          {{ badgeContent }}
        </span>
      }
    </button>
    `,
  styleUrls: ['./button.component.scss'],
  selector: 'ideapa-button',
})
export class ButtonComponent {
  @Input()
  cssClasses = '';

  @Input()
  type = 'button';

  @Input()
  icon = '';

  @Input()
  disabled? = false;

  @Input()
  text = '';

  @Input()
  badgeContent?: any;

  @Input()
  badgeClass = 'bg-danger';

  @Output()
  clicked = new EventEmitter<void>();

  get showBadge() {
    return !!this.badgeContent;
  }
}
